import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { SvgIcon } from '@mui/material';
import './TermArticles.scss';

export default function TermArticles(props) {
  return (
    <div className="term-articles justify-content-center mt-2">
      <Container>
        <Row className="justify-content-center">
          <h2 className="article-term text-center">{props.data.Title}</h2>
        </Row>
        <Row className="justify-content-center">
          <p className="section-text">{props.data.subtitle}</p>
        </Row>
        <Row className="mt-5 ms-1">
          {props.data.steps.map((step, index) =>
            <Col key={index} className="term-main"md={4}  xs={12} >
              <Row>
                <Col xs={2} className="ps-0">
                <div className="icon-wrapper">
                  <SvgIcon component={step.icon} className="icon" viewBox="0 0 40 40" />
                </div>
                </Col>
                <Col xs={10} className="ps-0"> 
                <div><h6 className="term-article"> {step.title}</h6></div>
                <p className="term-paragraph">{step.paragraph}</p></Col>
              </Row>
            </Col>
          )}
        </Row>
      </Container >
    </div >
  )
}
